import Splide from '@splidejs/splide';

const EL = '.js-SingleGallery';

document.querySelectorAll(EL).forEach(sliderElement => {
  new Splide(sliderElement, {
    type: 'fade',
    pagination: true,
    arrows: true,
    pauseOnFocus: false,
    classes: {
      arrows: 'splide__arrows',
      arrow : 'splide__arrow',
      prev  : 'splide__arrow--prev',
      next  : 'splide__arrow--next',
      pagination: 'splide__pagination',
      page: 'splide__pagination__page'
    },
  }).mount();
});
